import React, { forwardRef, ComponentProps } from 'react';

import Icon, { IconWithRender, generateRenderedIcon } from './Icon';
import { VIEWBOXES } from '../consts';
import { IconVariations } from '../useIconVariation';

const draw16px =
  'M7.384,5.442l-1.64-1.63V10a.75.75,0,0,1-1.5,0V3.812l-1.63,1.63a.75.75,0,0,1-1.06-1.06l2.91-2.91a.759.759,0,0,1,.38-.21c.05,0,.1-.01.15-.01s.1.01.15.01a.759.759,0,0,1,.38.21l2.92,2.91a.754.754,0,0,1,0,1.06.748.748,0,0,1-1.06,0Zm7.06,5.1a.754.754,0,0,0-1.06,0l-1.64,1.64V6a.75.75,0,1,0-1.5,0v6.18l-1.63-1.64a.754.754,0,0,0-1.06,0,.737.737,0,0,0,0,1.06l2.82,2.82.09.1c.03.03.07.06.11.1a.961.961,0,0,0,.28.11.66.66,0,0,0,.14.01.757.757,0,0,0,.15-.01,1.024,1.024,0,0,0,.27-.11,1,1,0,0,0,.11-.1l.05-.04,2.87-2.88A.754.754,0,0,0,14.444,10.542Zm-3.59,4.19a.34.34,0,0,0,.14.02.772.772,0,0,0,.15-.02.757.757,0,0,1-.15.01A.66.66,0,0,1,10.854,14.732Z';
const draw24px =
  'M11.44,7.45a.71.71,0,0,1-.53.22.74.74,0,0,1-.53-.22L8.75,5.81v9.51a.75.75,0,0,1-1.5,0V5.81L5.61,7.45A.75.75,0,0,1,4.55,6.39L7.47,3.47a.78.78,0,0,1,.24-.16.73.73,0,0,1,.58,0,.78.78,0,0,1,.24.16l2.91,2.92A.74.74,0,0,1,11.44,7.45Zm5.09,13.08a.74.74,0,0,1-.53.22.71.71,0,0,1-.53-.22l-.18-.18a.74.74,0,0,0,1.41,0Zm2.91-4a.75.75,0,0,0-1.06,0l-1.63,1.63V8.8a.75.75,0,0,0-1.5,0v9.39l-1.64-1.63a.75.75,0,0,0-1.06,1.06l2.74,2.73.18.18a.71.71,0,0,0,.53.22.74.74,0,0,0,.53-.22l.17-.17,2.74-2.74A.74.74,0,0,0,19.44,16.56Z';

const icons: IconVariations = {
  _16: { d: draw16px, viewBox: VIEWBOXES._16 },
  _24: { d: draw24px, viewBox: VIEWBOXES._24 },
};

const ArrowUpDownIcon = forwardRef<SVGSVGElement, ComponentProps<typeof Icon>>(
  generateRenderedIcon(icons, 'arrowUpDown'),
) as IconWithRender;

ArrowUpDownIcon.displayName = 'ArrowUpDownIcon';
ArrowUpDownIcon.propTypes = Icon.propTypes;
ArrowUpDownIcon.renderIcon = (props) => <ArrowUpDownIcon {...props} />;
export default ArrowUpDownIcon;
